import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const insightsPortalDataExplorerAccessControl: DomainAccessControlConfig = {
  permissions: Permission.DataExplorer,
}
